/* Líneas acompañantes del carrito (instalación de bomba de calor).
 *
 * La línea de instalación lleva la propiedad oculta `_equipo_variant` con el
 * id de variante del equipo al que acompaña. Cada vez que el carrito cambia
 * (PUB_SUB_EVENTS.cartUpdate con el carrito completo, o sea /cart/change.js),
 * se iguala su cantidad a la del equipo: si el equipo ya no está, se quita.
 *
 * Reutiliza CartItems.updateQuantity de assets/cart.js (hace el POST y pinta
 * las secciones). Como ese método busca #Quantity-N / #Drawer-quantity-N, el
 * input de cantidad de estas líneas se oculta con CSS, no se quita del markup.
 *
 * El aviso Liquid de main-cart-items / cart-drawer (.fls-cart-orphan) es el
 * respaldo para cuando este script no corre.
 */
(function () {
  if (window.__flsCartCompanion) return;
  window.__flsCartCompanion = true;

  var MAX_INTENTOS = 3; // por línea, por si Shopify no acepta la cantidad pedida
  var intentos = {};
  var busy = false;

  function reconciliar(cart) {
    if (busy || !cart || !cart.token || !Array.isArray(cart.items)) return;
    var porVariante = {};
    cart.items.forEach(function (i) { porVariante[i.variant_id] = (porVariante[i.variant_id] || 0) + i.quantity; });
    for (var idx = 0; idx < cart.items.length; idx++) {
      var it = cart.items[idx];
      var eq = it.properties && it.properties._equipo_variant;
      if (!eq) continue;
      var target = porVariante[Number(eq)] || 0;
      if (it.quantity === target) continue;
      var k = it.key || String(it.id);
      intentos[k] = (intentos[k] || 0) + 1;
      if (intentos[k] > MAX_INTENTOS) continue;

      var host = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (!host || typeof host.updateQuantity !== 'function') return;
      var line = idx + 1;
      // Dawn compara la cantidad devuelta con el value del input: se iguala
      // antes para que no pinte «solo puedes agregar N».
      var qEl = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
      if (qEl) qEl.value = target;
      busy = true;
      try {
        host.updateQuantity(line, target, { currentTarget: null }, undefined, it.variant_id);
      } finally {
        // updateQuantity no devuelve la promesa; el cartUpdate que publica al
        // terminar vuelve a pasar por aquí y corrige lo que falte.
        setTimeout(function () { busy = false; }, 0);
      }
      return; // una corrección por ciclo
    }
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      // Solo payloads de carrito completo (traen token). El de /cart/add.js
      // trae solo las líneas añadidas y no sirve para comparar.
      reconciliar(ev && ev.cartData);
    });
    return true;
  }

  if (!init()) document.addEventListener('DOMContentLoaded', init);
})();
